import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-service-object-type-ints',
  templateUrl: './service-object-type-ints.component.html',
  styleUrls: ['./service-object-type-ints.component.css']
})
export class ServiceObjectTypeIntsComponent implements OnInit {
    serviceObjectTypeKeyno;

    public setting?: Setting;

    public itemsListIntervals: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.serviceObjectTypeKeyno = this.stateService.getStateParams()['serviceobjecttype_keyno'];
    }

    private async loadSetting() {
        if (!!this.serviceObjectTypeKeyno) {
            this.setting = (await this.datatask.Post(1743, { serviceobjecttype_keyno: this.serviceObjectTypeKeyno }))[0];
        }
    }

    private async loadIntervals(): Promise<void> {
        if (!!this.serviceObjectTypeKeyno) {
            this.itemsListIntervals = await this.datatask.Post(1744, { serviceobjecttype_keyno: this.serviceObjectTypeKeyno });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'serviceobjecttypeint':
                this.stateService?.go('serviceobjecttypeint', {
                    serviceobjecttype_keyno: this.serviceObjectTypeKeyno,
                    serviceobjecttypeint_keyno: '0'
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadSetting();
        this.loadIntervals();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('serviceObjectTypeInts', {
//        templateUrl: 'views/components/views/serviceObjectTypeInts/serviceObjectTypeInts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'serviceObjectTypeIntsService', function ($stateParams, stateService, serviceObjectTypeIntsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let serviceObjectTypeKeyno = $stateParams.serviceobjecttype_keyno;

//            vm.model = {
//                setting: {},
//                itemsListIntervals: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            let loadSetting = function () {
//                serviceObjectTypeIntsService.getSetting({ serviceobjecttype_keyno: serviceObjectTypeKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.setting);
//                });
//            };

//            let loadIntervals = function () {
//                serviceObjectTypeIntsService.listIntervals({ serviceobjecttype_keyno: serviceObjectTypeKeyno }).then(function (list) {
//                    angular.copy(list, vm.model.itemsListIntervals);
//                });
//            };

//            // #endregion LOAD PROCEDURE CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'serviceobjecttypeint':
//                        go({
//                            serviceobjecttype_keyno: serviceObjectTypeKeyno,
//                            serviceobjecttypeint_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//                loadIntervals();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
